import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SEOToolsPanel = () => {
  const [activeSubTab, setActiveSubTab] = useState('meta');

  const subTabs = [
    { id: 'meta', label: 'Meta Tags', icon: 'Tag' },
    { id: 'sitemap', label: 'Sitemap', icon: 'Map' },
    { id: 'robots', label: 'Robots.txt', icon: 'Bot' },
    { id: 'analytics', label: 'Analytics', icon: 'BarChart3' }
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'meta':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-xl shadow-soft p-6">
                <h4 className="font-heading font-semibold text-lg text-text-primary mb-4">
                  Global Meta Tags
                </h4>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-text-primary mb-2">
                      Site Title
                    </label>
                    <Input placeholder="ShaadiNest - Wedding Vendor Platform" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-text-primary mb-2">
                      Meta Description
                    </label>
                    <textarea
                      placeholder="Find the perfect wedding vendors for your special day..."
                      rows={3}
                      className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-text-primary mb-2">
                      Keywords
                    </label>
                    <Input placeholder="wedding, vendors, photography, venues" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-soft p-6">
                <h4 className="font-heading font-semibold text-lg text-text-primary mb-4">
                  Social Media Meta
                </h4>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-text-primary mb-2">
                      OG Title
                    </label>
                    <Input placeholder="ShaadiNest - Wedding Vendor Platform" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-text-primary mb-2">
                      OG Description
                    </label>
                    <textarea
                      placeholder="Find the perfect wedding vendors..."
                      rows={3}
                      className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-text-primary mb-2">
                      OG Image URL
                    </label>
                    <Input placeholder="https://shaadinest.com/og-image.jpg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 'sitemap':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Map" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Sitemap Management
              </h3>
              <p className="text-text-secondary mb-6">
                Sitemap generation and submission tools coming soon
              </p>
              <Button variant="outline" disabled>
                Generate Sitemap
              </Button>
            </div>
          </div>
        );
      case 'robots':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Bot" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Robots.txt Editor
              </h3>
              <p className="text-text-secondary mb-6">
                Configure search engine crawling rules
              </p>
              <Button variant="outline" disabled>
                Edit Robots.txt
              </Button>
            </div>
          </div>
        );
      case 'analytics':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="BarChart3" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                SEO Analytics
              </h3>
              <p className="text-text-secondary mb-6">
                Track SEO performance and search rankings
              </p>
              <Button variant="outline" disabled>
                View Analytics
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          SEO Tools
        </h2>
        <p className="text-white/90">
          Optimize your platform for search engines
        </p>
      </div>

      {/* Sub Navigation */}
      <div className="bg-white rounded-xl shadow-soft p-6">
        <div className="flex flex-wrap gap-2">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                activeSubTab === tab.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:bg-surface-100'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub Tab Content */}
      {renderSubTabContent()}

      <div className="flex justify-end">
        <Button variant="primary" disabled>
          Save SEO Settings
        </Button>
      </div>
    </div>
  );
};

export default SEOToolsPanel;